import React from 'react';
import { PaletteIcon, CheckCircleIcon, BookOpenIcon, VideoIcon } from 'lucide-react';
export function ColorimetriaInfoSection() {
  return <section className="w-full bg-gradient-to-b from-[#111116] to-[#141418] py-6 md:py-16 px-4" data-id="element-56">
      <div className="max-w-5xl mx-auto" data-id="element-57">
        {/* Header — compact on mobile */}
        <div className="text-center mb-4 md:mb-12" data-id="element-58">
          <div className="flex items-center justify-center gap-1.5 md:gap-2 mb-2 md:mb-3" data-id="element-59">
            <PaletteIcon className="w-4 h-4 md:w-10 md:h-10 text-[#ef5350]" data-id="element-60" />
            <p className="text-[9px] md:text-sm text-[#ef5350] font-black tracking-widest uppercase" data-id="element-61">
              Incluido en Pack Completo
            </p>
          </div>
          <h2 className="text-base md:text-4xl font-black text-white mb-2 md:mb-4 leading-tight" data-id="element-62">
            Qué incluye la formación en{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ef5350] to-[#ff7043]" data-id="element-63">
              Colorimetría
            </span>
          </h2>
          <div className="w-10 md:w-16 h-0.5 bg-gradient-to-r from-[#e53935] to-[#ff7043] mx-auto mb-3 md:mb-6" data-id="element-64"></div>
          <p className="text-gray-400 text-[10px] md:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-65">
            Aprendé a trabajar con color de forma profesional: mezclas,
            pigmentos, tiempos de exposición y resultados reales.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 mb-6 md:mb-10" data-id="element-66">
          {/* Imagen — smaller on mobile */}
          <div className="flex justify-center items-center" data-id="element-67">
            <img src="https://cdn.magicpatterns.com/uploads/rh3A2iQ4JRbSVg1yJuF5Ev/colorimetria.png" alt="Formación en Colorimetría aplicada a barbería" className="w-full max-w-[180px] md:max-w-[320px] rounded-xl md:rounded-2xl shadow-2xl border-2 border-[#e53935]/20" data-id="element-68" />
          </div>

          {/* Contenido — compact on mobile */}
          <div className="flex flex-col justify-center" data-id="element-69">
            <h3 className="text-sm md:text-2xl font-black text-white mb-2 md:mb-4 leading-tight" data-id="element-70">
              Material profesional completo
            </h3>

            <div className="space-y-2 md:space-y-4 mb-3 md:mb-6" data-id="element-71">
              <div className="flex items-start gap-2 md:gap-3 bg-white/5 backdrop-blur-sm p-2.5 md:p-4 rounded-lg md:rounded-xl border border-white/10" data-id="element-72">
                <BookOpenIcon className="w-4 h-4 md:w-6 md:h-6 text-[#ef5350] flex-shrink-0 mt-0.5" data-id="element-73" />
                <div data-id="element-74">
                  <p className="text-white font-bold text-[10px] md:text-base mb-0.5 md:mb-1" data-id="element-75">
                    Ebook profesional de 60 páginas
                  </p>
                  <p className="text-gray-400 text-[9px] md:text-sm leading-snug" data-id="element-76">
                    PDF descargable con teoría completa del color aplicada a
                    barbería
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-2 md:gap-3 bg-white/5 backdrop-blur-sm p-2.5 md:p-4 rounded-lg md:rounded-xl border border-white/10" data-id="element-77">
                <VideoIcon className="w-4 h-4 md:w-6 md:h-6 text-[#ef5350] flex-shrink-0 mt-0.5" data-id="element-78" />
                <div data-id="element-79">
                  <p className="text-white font-bold text-[10px] md:text-base mb-0.5 md:mb-1" data-id="element-80">
                    Material audiovisual de apoyo
                  </p>
                  <p className="text-gray-400 text-[9px] md:text-sm leading-snug" data-id="element-81">
                    Videos explicativos con técnicas y aplicaciones prácticas
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#e53935]/10 to-[#ff7043]/5 border border-[#e53935]/20 rounded-lg md:rounded-xl p-3 md:p-5" data-id="element-82">
              <h4 className="text-white font-black text-[10px] md:text-base mb-2 md:mb-3" data-id="element-83">
                Vas a aprender:
              </h4>
              <div className="grid grid-cols-2 md:grid-cols-1 gap-1.5 md:gap-2" data-id="element-84">
                {['Teoría del color aplicada', 'Mezclas y pigmentos', 'Tiempos de exposición', 'Corrección de colores', 'Decoloración segura', 'Ampliar tus servicios'].map(item => <div key={item} className="flex items-start gap-1 md:gap-2" data-id="element-85">
                    <CheckCircleIcon className="w-3 h-3 md:w-4 md:h-4 text-[#ef5350] flex-shrink-0 mt-0.5" data-id="element-86" />
                    <span className="text-gray-300 text-[9px] md:text-sm font-semibold leading-tight" data-id="element-87">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-88">
          <p className="text-gray-500 text-[9px] md:text-base leading-relaxed max-w-2xl mx-auto" data-id="element-89">
            La colorimetría te permite ampliar tu oferta de servicios y
            diferenciarte en el mercado.
          </p>
        </div>
      </div>
    </section>;
}